import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { provideTranslation } from '@skyeng/libs/shared/i18n';
import { VimbotNotifierService } from './services/vimbot-notifier.service';
import { NotificationItemList, NotificationsUnreadCount } from './types';
import { DecorateUntilDestroy, takeUntilDestroyed } from '@skyeng/libs/shared/rxjs';

@DecorateUntilDestroy()
@Component({
  selector: 'crm-vimbot-notifier-top-header',
  templateUrl: './vimbot-notifier.component.html',
  styleUrls: ['./vimbot-notifier.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [provideTranslation('vimbotNotifierTopHeader', () => import.meta.webpackContext!('./translation'))],
})
export class VimbotNotifierComponent implements OnInit {
  count: NotificationsUnreadCount;
  notifications: NotificationItemList | null;
  displayedColumns = ['personId', 'chatType', 'message', 'updatedAt'];

  constructor(private router: Router, private headerService: VimbotNotifierService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.refresh();
    this.getUnreadCount();
    this.getNotifications();
  }

  open(item: any): void {
    this.router.navigate(['/', 'persons', item.personId, 'communications', 'vimbot'], {
      queryParams: { chatType: item.chatType },
    });

    setTimeout(() => {
      this.headerService.refreshUnreadCount();
      this.headerService.refreshNotifications();
    }, 3000);
  }

  private refresh(): void {
    const refresh = (): void => {
      this.headerService.refreshUnreadCount();
      this.headerService.refreshNotifications();

      setTimeout(refresh, 100000);
    };

    refresh();
  }

  private getUnreadCount(): void {
    this.headerService
      .getUnreadCount()
      .pipe(takeUntilDestroyed(this))
      .subscribe(count => {
        this.count = count;
        this.cdr.markForCheck();
      });
  }

  private getNotifications(): void {
    this.headerService
      .getNotifications()
      .pipe(takeUntilDestroyed(this))
      .subscribe(notifications => (this.notifications = notifications));
  }
}
